
import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import Provider from '@/interfaces/provider';

const Constant = namespace('constant');

@Component({
	name: 'SportWatchNowButton',
	components: { ProviderIcon },
})
export default class SportWatchNowButton extends Vue {
	@Prop({ required: true }) clickoutUrl: string;
	@Prop({ required: true }) packageId: number;
	@Prop({ default: false }) lazy: boolean;

	@Constant.Getter providersById: Record<string, Provider>;
}
